export const Welcome = 'welcome';

export const WelcomeView = `/${Welcome}`;
